import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-text-overlay__controls" }
const _hoisted_2 = ["onPaste", "onKeydown"]

import { nextTick, ref, toRefs, watch } from 'vue'
import TextControlButton from '@/components/preview/TextControlButton.vue'
import DeleteIcon from '@/assets/DeleteIcon.svg'
import DoneIcon from '@/assets/DoneIcon.svg'
import { useProjectStore } from '@/store/project-store'
import { useApplicationStore } from '@/store/application-store'
import useTextStates from '@/composables/UseTextStates'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTextOverlay',
  props: {
    showOverlay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  showOverlay: boolean
};

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()



const { showOverlay } = toRefs(props)
const textArea = ref<HTMLSpanElement | null>(null)

const {
  addText,
  saveText,
  deleteText,
  getMaxWidth
} = useTextStates()

const onInput = () => {
  if (textArea.value && applicationStore.currentEditingText) {
    // remove images
    const imageRegex = /<img[^>]*>/g
    if (textArea.value.innerHTML.match(imageRegex)) {
      textArea.value.innerHTML = textArea.value.innerHTML.replace(imageRegex, '')
      setCaretAtEndOfText()
    }

    // update the text with a new value
    applicationStore.currentEditingText.text = textArea.value.innerText
    if (applicationStore.editTextState === 'adding') {
      applicationStore.currentEditingText.x = textArea.value.offsetLeft + textArea.value.offsetWidth / 2
      applicationStore.currentEditingText.y = textArea.value.offsetTop + textArea.value.offsetHeight / 2
    }
  }
}

const onPaste = (event: ClipboardEvent) => {
  if (textArea.value && event.clipboardData) {
    textArea.value.innerHTML = event.clipboardData.getData('text/plain')
    onInput()
    setCaretAtEndOfText()
  }
}

const onDelete = () => {
  if (textArea.value) {
    if (projectStore.textStates.length === 0 && applicationStore.editTextState === 'adding') {
      // Clear text
      textArea.value.innerText = ''
      textArea.value.focus()
    } else {
      if (applicationStore.currentEditingText) {
        deleteText(applicationStore.currentEditingText)

        if (projectStore.textStates.length > 0) {
          // Set the selected text to be the last one added
          applicationStore.selectText(projectStore.textStates[projectStore.textStates.length - 1])
        } else {
          // Reset to new text state
          textArea.value.innerText = ''
          addText({ style: applicationStore.selectedText?.style })
        }
      }
    }
  }
}

const onDone = () => {
  // should never happen
  if (textArea.value === null) {
    return
  }

  // get text length excluding whitespace and newlines
  const strLength = textArea.value.innerText.trim().length

  // if there is no valid text, delete whitespace and newlines and set the caret at the end
  if (strLength === 0) {
    textArea.value.innerText = ''
    setCaretAtEndOfText()
    return
  }

  if (applicationStore.currentEditingText) {
    saveText(applicationStore.currentEditingText)
    textArea.value.innerText = ''
  }
}

const handleDeselectTextInput = (event: Event) => {
  if (event.target === event.currentTarget) {
    // Save when user clicks off target
    onDone()
  }
}

const setCaretAtEndOfText = () => {
  if (textArea.value) {
    const range = document.createRange()
    range.selectNodeContents(textArea.value)
    range.collapse(false)

    const selection = window.getSelection()
    if (selection) {
      selection.removeAllRanges()
      selection.addRange(range)
    }
  }
}

watch(showOverlay, async () => {
  if (!showOverlay.value) {
    onDone()
    return
  }
  
  if (textArea.value && applicationStore.currentEditingText) {
    textArea.value.innerText = applicationStore.currentEditingText.text
    await nextTick()
    setCaretAtEndOfText()
    applicationStore.currentEditingText.style.maxWidth = getMaxWidth()
    applicationStore.selectedText = applicationStore.selectedText ?? applicationStore.currentEditingText
  }
})

watch(() => projectStore.resolution, () => {
  if (applicationStore.currentEditingText && applicationStore.editTextState !== 'none') {
    applicationStore.currentEditingText.style.maxWidth = getMaxWidth()
  }
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "edit-text-overlay",
    onClick: handleDeselectTextInput
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(TextControlButton, {
        text: "Delete",
        onClick: onDelete
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DeleteIcon), { class: "edit-text-overlay__controls-icon" })
        ]),
        _: 1
      }),
      _createVNode(TextControlButton, {
        text: "Done",
        onClick: onDone
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DoneIcon), { class: "edit-text-overlay__controls-icon" })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _unref(applicationStore).currentEditingText?.text]
    ]),
    _createElementVNode("span", {
      ref_key: "textArea",
      ref: textArea,
      class: "edit-text-overlay__text",
      contenteditable: "",
      style: _normalizeStyle(_unref(applicationStore).currentEditingText?.cssStyle),
      onInput: onInput,
      onPaste: _withModifiers(onPaste, ["prevent"]),
      onKeydown: _withKeys(_withModifiers(onDone, ["exact","prevent"]), ["enter"])
    }, null, 44, _hoisted_2)
  ], 512)), [
    [_vShow, _unref(showOverlay)]
  ])
}
}

})